import { GoBackLinkButton } from "../../components/GoBackLinkButton";
import { routes } from "../../appRoutingHelpers";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { SpinnerBlock } from "../common/Spinner";
import { EmailTemplateUpsertForm } from "./EmailTemplateUpsertForm";
import * as authSelectors from "../auth/authSelectors";
import {
  useCreateEmailTemplate,
  useGetEmailTemplate,
  useUpdateEmailTemplate,
} from "../../service/api";
import { toastr } from "react-redux-toastr";
import { getErrorMessage, useHandleFetchError } from "../../error-handler";
import HeapsError from "../../heaps-error";

export const EmailTemplateUpsert = () => {
  const { id } = useParams<{
    id: string;
  }>();
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );
  const isEdit = !!id;
  const navigate = useNavigate();
  const {
    data: emailTemplate,
    isLoading: isLoadingEmailTemplate,
    error: emailTemplateError,
  } = useGetEmailTemplate(organizationKeyName, id);

  const {
    mutateAsync: createEmailTemplate,
    isLoading: isCreatingEmailTemplate,
  } = useCreateEmailTemplate();

  const {
    mutateAsync: updateEmailTemplate,
    isLoading: isUpdatingEmailTemplate,
  } = useUpdateEmailTemplate(id);

  const onEditSubmit = async (values: any) => {
    // TODO: Consider fixing EmailTemplateDTO
    const textBody = values.plainText;
    delete values.plainText;
    values.textBody = textBody;

    // TODO: ibid.
    const htmlBody = values.htmlText;
    delete values.htmlText;
    values.htmlBody = htmlBody;

    if (!id) {
      throw new HeapsError({
        errorMessage: "No email template id on edit submit",
        errorCode: "NO_EMAIL_TEMPLATE_ID_ON_EDIT_SUBMIT",
      });
    }
    await updateEmailTemplate({
      organizationKeyName,
      data: values,
      id,
    });
  };

  const onInsertSubmit = async (values: any) => {
    // TODO: ibid.
    const textBody = values.plainText;
    delete values.plainText;
    values.textBody = textBody;

    // TODO: ibid.
    const htmlBody = values.htmlText;
    delete values.htmlText;
    values.htmlBody = htmlBody;

    await createEmailTemplate({
      data: values,
      organizationKeyName,
    });
  };

  const onSubmit = async (values: any) => {
    try {
      if (isEdit) {
        await onEditSubmit(values);
      } else {
        await onInsertSubmit(values);
      }
      navigate(routes.emailTemplates(organizationKeyName));
      toastr.success(
        "Success",
        `Email template ${isEdit ? "updated" : "created"} successfully`
      );
    } catch (error: unknown) {
      const errorMessage = getErrorMessage(error);
      toastr.error("Error", errorMessage);
    }
  };

  useHandleFetchError(emailTemplateError);

  if (isLoadingEmailTemplate) {
    return <SpinnerBlock />;
  }

  return (
    <div className="container mt-5">
      <GoBackLinkButton
        to={routes.emailTemplates(organizationKeyName)}
        text="Back to all email templates"
      />
      <div className="row">
        <div className="col-12">
          <EmailTemplateUpsertForm
            onSubmit={onSubmit}
            emailTemplate={isEdit ? emailTemplate || {} : {}}
            isUpsertingEmailTemplate={
              isEdit ? isUpdatingEmailTemplate : isCreatingEmailTemplate
            }
          />
        </div>
      </div>
    </div>
  );
};
